import { Box } from "@mui/material";
import React, { useState } from "react";
import ReactPlayer from "react-player/youtube";
import WordpressThumbnail from "../../assets/wordpress_thumbnail.jpg";

const VideoThumbnail = ({ url }) => {
  const [showPlayer, setShowPlayer] = useState(false);

  // Extract YouTube video ID from URL
  const getYouTubeID = (url) => {
    const match = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^&]+)/
    );
    return match ? match[1] : null;
  };

  const videoId = getYouTubeID(url);
  const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <Box sx={{ width: "70%", display: "flex", justifyContent: "center" }}>
      <ReactPlayer url={url} controls width="100%" />
      {/* <video
        width="640"
        height="560"
        controls
        poster={WordpressThumbnail} // shows this before playing
      >
        <source
          src="https://www.youtube.com/watch?v=PI4fFtvNTjo"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video> */}
    </Box>
  );
};

export default VideoThumbnail;
